// utils/remitenteMensaje.js
// Quién respondió en el chat de soporte.
//
// `messages.user_name` guarda el nombre del admin que contestó desde la web
// (replyMessage usa el nombre del token). Las respuestas que entran por el
// webhook de Telegram no tienen usuario autenticado: se guardan como 'Admin'.
//
// Con varios admins conectados al mismo panel, mostrar el nombre le permite
// al usuario (y al otro admin) saber quién contestó.

export const nombreAdminRemitente = (mensaje) => {
	const nombre = typeof mensaje?.user_name === 'string' ? mensaje.user_name.trim() : '';
	if (!nombre) return null;
	const normalizado = nombre.toLowerCase();
	if (normalizado === 'admin' || normalizado === 'soporte') return null;
	return nombre;
};

export const etiquetaAdminRemitente = (mensaje) => {
	const nombre = nombreAdminRemitente(mensaje);
	return nombre ? `Soporte · ${nombre}` : 'Soporte';
};
